import React, { useEffect, useState } from 'react'

// redux
import { connect } from 'react-redux'

// bootstrap
import { Modal, Spinner } from 'react-bootstrap'

// icons : feather
import FeatherIcon from 'feather-icons-react';

// formik
import {
    useFormik, //hook for functonal components
} from 'formik'

// yup
import * as Yup from 'yup'

// images
import noImgFound from 'assets/images/no-img-found.png'

// toast
import { toast } from 'react-toastify'

// app messages
import {
    ERROR_WHILE__NAME,
    UNKNOWN_ERROR_OCCURED
} from 'utlis/AppMessages/AppMessages'

// form fields
import AppFormikInput from 'utlis/helpers/forms/AppFormikInput'
import AppFormikTextarea from 'utlis/helpers/forms/AppFormikTextarea';

// APIs
import { sendCustomMessage } from 'utlis/Apis/AbandonedCart_API';

function SendEmailModal(props) {
    // props
    const {
        authState,
        modalVisibility,
        closeModal,

        orderDetails,
        tempOrderId,

    } = props

    // consts
    const DEFAULT_SUBJECT = "You left items in your cart"
    const DEFAULT_MESSAGE = "It looks like you left some items in your shopping cart. Don’t worry, we saved your cart so you can pick up where you left off. But don’t wait too long. Get your items before they’re gone."

    // states
    const [allproducts, setAllProducts] = useState([])
    const [btnLoading, setBtnLoading] = useState(false)
    const [btnDisabled, setBtnDisabled] = useState(false)

    // initial form values
    const initialFormValues = {
        to: "",
        subject: DEFAULT_SUBJECT || "",
        message: DEFAULT_MESSAGE || "",
    }

    // handle form validations
    const formValidationSchema = Yup.object({
        to: Yup.string().required('This field is required'),
        subject: Yup.string().required('This field is required'),
        message: Yup.string().required("This field is required"),
    })

    // handle form submmision
    const onFormSubmit = values => {
        if (values && tempOrderId) { // if values are temprory order id exists

            // btn loading
            setBtnLoading(true)
            setBtnDisabled(true)

            const requiredData = {
                temp_order_id: tempOrderId,
                subject: values.subject,
                message: values.message,
            }

            const headers = {
                "Authorization": `Bearer ${authState.commonToken}`,
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }

            // network request
            sendCustomMessage(headers, requiredData).then(res => {
                // btn loading
                setBtnLoading(false)
                setBtnDisabled(false)

                const resData = res?.data

                closeModal() // closing the modal

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the success message
                toast.success(resData?.message || "Recovery email sent successfully.", {
                    autoClose: 2500
                });

                // if request is success
                // if (resData?.success) {
                //     closeModal && closeModal() // closing the modal

                // }

                // // if request is error
                // if (resData?.error) {
                //     // dismissing all the previous toasts first
                //     toast.dismiss();

                //     // showing the error message
                //     toast.error(resData?.message || UNKNOWN_ERROR_OCCURED, {
                //         autoClose: 2500
                //     });
                // }
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} updateOrderStatus`, err.message);

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onclose: () => {
                        // btn loading
                        setBtnLoading(false)
                        setBtnDisabled(false)
                    }
                });
            })
        }
    }

    // formik hook
    const formik = useFormik({
        initialValues: initialFormValues,
        validationSchema: formValidationSchema,
        onSubmit: onFormSubmit,
    })

    useEffect(() => {
        if (orderDetails?.content?.length) {
            formik.setFieldValue("to", orderDetails.content[0]?.email) // setting default email

            setAllProducts(orderDetails.content) // setting all products
        }
    }, [orderDetails])

    return (
        <Modal
            show={modalVisibility}
            onHide={closeModal}
            centered
            size={"lg"}
            className="st-info-modal">
            <Modal.Body className="st-modal">
                {/* close icon */}
                <div className="app-modal-content modal_send-recovery-email position-relative pt-0" style={{ minHeight: 'auto' }}>
                    <button
                        className="close-icon position-absolute st-round-btn st-btn-sm st-btn-white d-flex align-items-center justify-content-center"
                        onClick={closeModal}
                        style={{ top: 0, right: 0 }}>
                        <FeatherIcon
                            icon="x"
                            size="20"
                            className="icon position-relative"
                        />
                    </button>

                    {/* head */}
                    <div className="app-modal-title-wrapper">
                        <p className="app-modal-title">Send Recovery Email</p>
                    </div>

                    <div className="form">
                        <form onSubmit={formik.handleSubmit}
                            noValidate
                            autoComplete="off">
                            {/* input */}
                            <AppFormikInput
                                formik={formik} // formik object
                                stFormClass={""} // class name for main wrapper
                                labelName={"To"} // label name
                                isRequired={true} // is this field is required or not to show the red star sign
                                placeholder={"To"} // placeholder for the input
                                formikFieldName={"to"} // important: formik value name for the input
                                disabled={true} // to make the input diabled
                            />

                            {/* input */}
                            <AppFormikInput
                                formik={formik} // formik object
                                stFormClass={""} // class name for main wrapper
                                labelName={"Subject"} // label name
                                isRequired={true} // is this field is required or not to show the red star sign
                                placeholder={"Subject"} // placeholder for the input
                                formikFieldName={"subject"} // important: formik value name for the input
                            />

                            {/* textarea */}
                            <AppFormikTextarea
                                formik={formik} // formik object
                                stFormClass={"mb-0"} // class name for main wrapper
                                labelName={"Custom message for this customer:"} // label name
                                placeholder={"Custom message for this customer:"} // placeholder for the input
                                textareaRows={"3"} // rows for textarea
                                formikFieldName={"message"} // important: formik value name for the input
                            />
                            <div className="add-info mt-1 st-text-color2">Add a discount coupon to your email and mention your offer in the subject to increase the chances of succesfull sale.</div>

                            {/* product view */}
                            <div className="product-view pt-3 pt-lg-4">
                                <p className="head st-fw-600 st-text-color2 st-fs-16 mb-3">Order items: <span>{orderDetails.cart_items}</span></p>

                                <div className="inner table-responsive">
                                    <table className="table">
                                        <tbody>
                                            {
                                                allproducts?.length ? allproducts.map((item, index) => {
                                                    if (index < 2) {
                                                        return (
                                                            <tr key={item.cart_id}>
                                                                <td>
                                                                    <div className="item-inner d-flex flex-wrap position-relative">
                                                                        {/* img sec */}
                                                                        <div className="img-sec position-relative" style={{ width: 45, top: 3 }}>
                                                                            <img
                                                                                src={orderDetails?.images[item.cart_id] || noImgFound}
                                                                                alt=""
                                                                                className="img-fluid img-fluid-height"
                                                                            />
                                                                        </div>

                                                                        {/* text sec */}
                                                                        <div className="text-sec media-body st-line-height-normal position-relative ps-2">
                                                                            <p className="mb-0 st-fw-600">{item.product_name}</p>
                                                                            <p className="mb-0">{item.variant_name}</p>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <p className="mb-0">{item.quantity}x</p>
                                                                </td>
                                                                <td>
                                                                    <p className="mb-0 st-fw-600">{item.total_price}</p>
                                                                </td>
                                                            </tr>
                                                        )
                                                    } else {
                                                        return null
                                                    }
                                                }) : (
                                                    <tr>
                                                        <td colSpan="4">
                                                            <p className="mb-0 st-fw-600">no product found</p>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>

                                    {
                                        (allproducts?.length > 2) ? (
                                            <p className="st-fw-600 st-text-primary">
                                                +{orderDetails.cart_items - 2} more
                                            </p>
                                        ) : null
                                    }
                                </div>
                            </div>


                            <div className="btns mt-3 mt-lg-4" style={{ width: 200 }}>
                                <button
                                    type="submit"
                                    className={`st-btn st-btn-primary text-capitalize w-100 ${btnDisabled ? "disabled" : ""}`}
                                    disabled={btnDisabled}>
                                    {
                                        btnLoading ? (
                                            <Spinner animation="border" size="sm" />
                                        ) : (
                                            <span>Send Email</span>
                                        )
                                    }
                                </button>
                            </div>
                        </form>
                    </div>

                </div>
            </Modal.Body>
        </Modal>
    )
}

const getDataFromStore = state => {
    return {
        authState: state.auth,
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        // setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(SendEmailModal)